import React from 'react';

const OxygenTherapy = () => (
    <div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    氧氣治療與非侵襲性陽壓呼吸器使用    
                </h1>
            </div>

            {/* 6.1 氧氣治療 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 mb-10">
                <h2 className="text-2xl font-bold text-green-800 mb-4">氧氣治療</h2>
                <p className="mb-4">
                    經過醫師評估後，符合下列條件的病人，建議每天使用氧氣治療至少15小時，這樣可以減輕心臟與肺部的負擔，也有助於降低死亡風險。
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                    <li>
                        在休息狀態下、未使用氧氣時，動脈血氧分壓 ≤ 55 毫米汞柱，或血氧飽和度 ≤ 88%。
                    </li>
                    <li>
                        在休息狀態下、未使用氧氣時，動脈血氧分壓為 56–59 毫米汞柱，或血氧飽和度為 89%，且同時出現以下任一情況：
                        <ul className="list-disc pl-6 mt-2 space-y-1">
                            <li>身體水腫（可能與心臟功能有關）</li>
                            <li>血液中的紅血球數過多（血容比 ≥ 55%）</li>
                            <li>合併肺動脈高壓</li>
                        </ul>
                    </li>
                </ul>
                <p className="mb-2">
                    此外，如果在活動或運動後，血氧飽和度下降至88%以下，建議使用可攜式氧氣裝置，能幫助改善運動能力與生活品質。
                </p>
            </div>

            {/* 6.2 非侵襲性陽壓呼吸器 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 mb-10">
                <h2 className="text-2xl font-bold text-green-800 mb-4">非侵襲性陽壓呼吸器</h2>
                <p className="mb-4">
                    對部分COPD病人來說，單純使用氧氣治療可能無法完全改善呼吸功能，尤其是當血中二氧化碳濃度上升時，會導致第二型呼吸衰竭，這種情況稱為氧氣治療失敗，需要特別留意以下幾項徵兆：
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                    <li>即使使用了藥物和氧氣，症狀仍未明顯改善</li>
                    <li>動脈血液的酸鹼值（pH）低於 7.35，代表身體偏酸</li>
                    <li>血氧飽和度仍持續低於 88%</li>
                    <li>動脈血中二氧化碳壓力超過 45 毫米汞柱</li>
                </ul>
                <p className="mb-4">
                    當出現上述情況時，建議由醫師評估是否需進一步使用呼吸器輔助治療。呼吸器治療有兩種方式：
                </p>
                <ul className="list-disc pl-6 mb-2 space-y-1">
                    <li>
                        <span className="font-semibold text-green-800">非侵襲性呼吸器（NIPPV）：</span>
                        透過面罩提供呼吸輔助，無需插管。
                    </li>
                    <li>
                        <span className="font-semibold text-green-800">侵襲性呼吸器：</span>
                        需經由插管或氣切方式協助呼吸，通常在加護病房使用。
                    </li>
                </ul>
            </div>

            {/* 資料來源 */}
            <div className="bg-white rounded-2xl shadow p-6 text-sm text-gray-700">
                <div className="font-bold mb-2">資料來源：</div>
                <ul className="list-disc pl-6 space-y-1">
                    <li>
                        <a href="https://goldcopd.org" target="_blank" rel="noopener noreferrer" className="text-gray-800 underline">Global Initiative for Chronic Obstructive Lung Disease (GOLD). (2025). Global strategy for the prevention, diagnosis and management of chronic obstructive pulmonary disease: 2025 report.</a>
                    </li>
                    <li>
                        <a href="https://asthma-copd.tw/book.php?id=1" target="_blank" rel="noopener noreferrer" className="text-gray-800 underline">有氧！走遍天下。台灣胸腔暨重症加護醫學會。</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
);

export default OxygenTherapy; 